import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ListaPrecio } from 'app/models/listaprecio.models';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ListaprecioService {

  constructor(private http: HttpClient) { }

  getListaPrecios(): Observable<ListaPrecio | any> {
    return this.http.get(environment.apiUrl + 'price-list');
  }

  getNextNumber(): Observable<any> {
    return this.http.get(environment.apiUrl + 'price-list/next-number');
  }

  guardarListaPrecio(lista: ListaPrecio): Observable<any> {
    return this.http.post(environment.apiUrl + 'price-list', lista);
  }
}
